<template>
  <footer class="footer">
    <div class="footer-inner container">
      <div class="footer-col">
        <p><NuxtLink to="/help/about?id=4" class="footer-link">关于我们</NuxtLink></p>
        <p><NuxtLink to="/help/about?id=5" class="footer-link">产品质量</NuxtLink></p>
        <p><NuxtLink to="/help/about?id=6" class="footer-link">规则条款</NuxtLink></p>
        <p><NuxtLink to="/help/contact" class="footer-link">联系我们</NuxtLink></p> 
      </div>
      <div class="footer-bottom container">
        <div>
          <p>联系地址：广东省罗湖区洪湖路湖景花园湖清阁30D</p>
          <p>联系电话 (同微信)：(+86) 195 3762 1060 / 136 9224 8397</p>
          <p>联系邮箱：services@yoostone.com</p>
          <p>邮政编码：518020</p>
        </div>
        <a
          class="copyright"
          href="http://beian.miit.gov.cn/"
          target="_blank"
          rel="noopener"
        >粤ICP备2025510528号-1</a>
      </div>
    </div>
    
  </footer>
</template>

<script setup lang="ts">
import { ref } from "vue";
const email = ref("");
</script>

<style scoped>
.footer {
  background: #eceff1;
  padding: 0.8rem 0 0.4rem;
}
.container {
  width: 100%;
  padding: 0 0.9rem;
}
.footer-inner {
  display: grid;
  grid-template-columns: 1fr 2fr;
  column-gap: 1.2rem;
  row-gap: 0.4rem;
  align-items: start;
}
.footer-title {
  font-weight: 600;
  margin-bottom: 0.14rem;
  font-size: 0.16rem;
}
.footer-col p {
  font-size: 0.16rem;
  line-height: 2;
  margin: 0;
  color: #333;
}
.footer-title.en {
  font-weight: 600;
}
.footer-col .footer-text {
  color: #121212;
  margin-bottom: 0.16rem;
  font-size: 0.14rem;
}
.footer-btn {
  margin-top: 0.16rem;
  background: #121212;
  border-color: #121212;
  color: #fff;
  height: 0.64rem;
  width: 1.6rem;
}
.footer-bottom {
  padding-bottom: 0.4rem;
  font-size: 0.14rem;
  line-height: 0.26rem;
}
.copyright {
  color: #666;
  font-size: 0.14rem;
}
.footer-input:deep(.el-input__wrapper) {
  min-height: 0.44rem;
  height: 0.44rem;
}
.footer-input:deep(.el-input__inner) {
  height: 0.44rem;
  line-height: 0.44rem;
}
.news .el-input {
  width: 3.6rem;
}
.news .footer-btn {
  width: 1.2rem;
}
.footer-col a {
  font-size: 0.16rem;
  line-height: 2;
  margin: 0;
  color: #333;
  text-decoration: none;
}
@media (max-width: 960px) {
  .footer-inner {
    grid-template-columns: 1fr;
  }
}
</style>
